import { OktaAuth } from "@okta/okta-auth-js";

const PROD_OKTA_OAUTH = "https://suki-api.okta.com";
const PROD_OKTA_URL = "https://suki-api.okta.com/oauth2/default";
const SANDBOX_OKTA_OAUTH = "https://suki-sandbox.oktapreview.com";
const SANDBOX_OKTA_URL = "https://suki-sandbox.oktapreview.com/oauth2/default";

const REDIRECT_URI = window.location.origin;

const isEnvironmentTest = () => window.location.origin.match(/test/i);
const isEnvironmentStage = () => window.location.origin.match(/stage/i);
const isEnvironmentProd = () => window.location.origin.match(/suki\.ai/i);

const getClientIdByEnv = () => {
  let clientId = "0oa1q1jlt397o56p60h8";
  if (isEnvironmentTest()) {
    clientId = "0oav6umfwhlRWsRA40h7";
  } else if (isEnvironmentStage()) {
    clientId = "0oav6v3pptKZewqd00h7";
  } else if (isEnvironmentProd()) {
    clientId = "0oa531v6hlyxRYZoX297";
  }
  return clientId;
};

const oktaConfig = {
  issuer: isEnvironmentProd() ? PROD_OKTA_OAUTH : SANDBOX_OKTA_OAUTH,
  url: isEnvironmentProd() ? PROD_OKTA_URL : SANDBOX_OKTA_URL,
  clientId: getClientIdByEnv(),
  redirectUri: REDIRECT_URI,
  pkce: false,
  tokenManager: {
    autoRenew: true
  }
};

const oktaAuth = new OktaAuth(oktaConfig);

export { oktaAuth, oktaConfig, REDIRECT_URI };

export default oktaAuth;
